import { render } from "./promoItemsList.vue?vue&type=template&id=b71cc5f0"
import script from "./promoItemsList.vue?vue&type=script&lang=js"
export * from "./promoItemsList.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__